import React from "react";
import { Button, Typography } from "antd";
import { MailOutlined } from "@ant-design/icons";
import supportImage from "../../assets/images/support_image.png";
const { Title, Text } = Typography;

const SupportPanel = () => {
  const handleSendMail = () => {
    const email =  "info@koletra.com";
    window.location.href = `mailto:${email}?subject=Destek Talebi`;
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        textAlign: "center",
      }}
    >

      <img
        src={supportImage}
        alt="403"
        style={{
          width: 550,
          maxWidth: "80%",
          marginBottom: 32,
          marginTop: "-100px",
        }}
      />


      <Title
        level={3}
        style={{
          marginBottom: 8,
          fontWeight: 600,
          color: "#000",
        }}
      >
        Size Nasıl Yardımcı Olabiliriz ?
      </Title>

      <Text
        style={{
          fontSize: 15,
          color: "rgba(0,0,0,0.65)",
          marginBottom: 32,
        }}
      >
        Destek ve talepleriniz için destek ekibiyle iletişime geçebilirsiniz.
      </Text>

      {/* Buton */}
      <Button
        type="primary"
        icon={<MailOutlined />}
        onClick={handleSendMail}
        size="middle"
      >
        E-Posta Gönder
      </Button>
    </div>
  );
}
export default SupportPanel;
